import { asyncAction } from 'lib/actionCreators'

export const superManagerClientsList = asyncAction('super_manager/CLIENTS_LIST')
